export default __webpack_public_path__ + "static/media/b06.464ca96a.jpg";